// import {Link} from 'react-router-dom';
// import {CustomMenu} from '../../../menus/custom-menu';
import {useSettings} from '../../../core/settings/use-settings';

export function AuthLayoutFooter() {
  const {branding} = useSettings();
  //done
  return (
    <div className="mt-auto flex items-center justify-center gap-5 pb-5 pt-12 text-center text-sm text-muted">
      <p> © {branding.site_name}</p>
    </div>
  );
}
